import { getCoreUtils, nz } from "../../../Admin/kReusableCoreTS/kCoreHandler";

// AppTaskTips - the task UI's tooltips, above all what the "who has to act" hint MEANS (owner,
// 2026-09-26: "The texts Both etc needs an explanation - put them in tooltip"). ONE place for the
// sentences, read by BOTH halves: the service's task strip (`TaskStateHtml`, a `title` on
// `<i class="who">` and on the "↗"), the app's Tasks tab (`AppTaskView`, `<span class="own">`) and the
// controls the app adds to the strip (`AppTaskFrame`). `TaskTips.test.ts` pins that they agree.
// Pure: no DOM, no transport - the Bridge imports it the way it imports `AppTaskApi`.
// ⚠ A second consumer only passes a different name; the sentences stay here.

export class AppTaskTips {
    /** On the "↗" that jumps to a task's evidence (page strip and Tasks tab). */
    public static readonly GoTip: string = "Go to the message this came from";
    /** On the "…" menu of a strip item. */
    public static readonly MenuTip: string = "Snooze or dismiss";
    /** On the "…" menu of a reply owed, which also offers Mark done. */
    public static readonly ReplyMenuTip: string = "Snooze, mark done or dismiss";

    /** The first word of a name - "Anna" of "Anna Karlsson"; "" for a number, a `lid:` id or a blank. */
    public static FirstName = (Title: string): string => {
        if (getCoreUtils().KErrorMode === true) { return ""; }
        try {
            const First: string = nz(Title).trim().split(/\s+/)[0];
            if (First.length === 0 || /\d/.test(First) === true || First.indexOf(":") >= 0) { return ""; }
            return First;
        } catch (e) {
            getCoreUtils().KGlobalErrorHandler(e, "AppTaskTips.FirstName");
            return "";
        }
    };

    /**
     * The explanation of an owner value (`me` / `them` / `both`), naming the contact by `First` when it
     * is known and "they" otherwise; "" when nobody said who acts. Plain text - the caller escapes it.
     */
    public static Explain = (Owner: string, First: string): string => {
        if (getCoreUtils().KErrorMode === true) { return ""; }
        try {
            const Name: string = nz(First).trim();
            if (Owner === "me") { return "You need to do this"; }
            if (Owner === "both" && Name.length > 0) { return "Both you and " + Name + " have something to do on this"; }
            if (Owner === "both") { return "Both you and they have something to do on this"; }
            if (Owner === "them" && Name.length > 0) { return Name + "'s move - you are waiting on " + Name; }
            if (Owner === "them") { return "Their move - you are waiting on them"; }
            return "";
        } catch (e) {
            getCoreUtils().KGlobalErrorHandler(e, "AppTaskTips.Explain");
            return "";
        }
    };

    // ⭐ THE STRIP'S "Done (N)" SECTION (owner, 2026-10-22: "Closing a task by mistake - there should be a collapsed
    // view of closed tasks, each with the option to re-open"). ONE set of words and rules for both halves: the page
    // writes it (`TaskStateHtml.Done`, script-free `<details>`), the app keeps it true (`AppTaskFrame.Shelve`).
    public static readonly ReopenWord: string = "Reopen";
    public static readonly DoneClass: string = "tdone";
    public static readonly DoneListClass: string = "tdlist";
    /** The folded section's summary: "Done (3)". DOCUMENTED EXCEPTION: pure. ERROR-SUPPRESSED-JUSTIFIED: cannot throw. */
    public static DoneTitle = (Count: number): string => {
        return "Done (" + String(Count) + ")";
    };
    /**
     * The section's rules - on a page that HAS a Done section (`DossierHtml.TaskCss`) and in the frame sheet
     * (`AppTaskFrame.Css`, for a section the app made). ⛔ Variables with fallbacks only, no inline style.
     * DOCUMENTED EXCEPTION: a constant stylesheet. ERROR-SUPPRESSED-JUSTIFIED: returns a literal.
     */
    public static DoneCss = (): string => {
        return ".tdone{margin:2px 0 0;font-size:13px}.tdone.wac-tdempty{display:none}"
            + ".tdone>summary{cursor:pointer;font-weight:600;color:var(--dim,#6b7385);padding:4px 0}"
            + ".tdlist{list-style:none;margin:0;padding:0;display:flex;flex-direction:column}"
            + ".tdlist .tk{display:flex}.tdlist .tk .tl{text-decoration:line-through;color:var(--dim,#6b7385);font-weight:400}"
            + ".tdlist .tk .due,.tdlist .tk .who{opacity:.5}"
            + ".tdlist .wac-tfreopen{flex:none;margin-left:auto;padding:2px 10px;border:1px solid var(--line,#d8dce4);"
            + "border-radius:4px;background:transparent;color:inherit;font:inherit;font-size:12px;font-weight:600;cursor:pointer}"
            + ".tdlist .wac-tfreopen+.tgo{margin-left:0}";
    };
}
